import React from 'react';
import {useTranslation} from 'react-i18next';
import {QuestionsTotalAnalytics} from '../../../../incase-domain/analytics';
import ReportProgressBar from '../../../../incase-domain/components/report/progressBar/ReportProgressBar';
import SkeletonLoader from '../../../components/common/SkeletonLoader';

interface AveragePointsReportProps {
    analytics: QuestionsTotalAnalytics | undefined;
    isLoading: boolean;
}

function AveragePointsReport({analytics, isLoading}: AveragePointsReportProps): JSX.Element {
    const {t} = useTranslation();

    return (
        <div>
            <div className="p-presReport__card_title">{t('reportPage.points')}</div>
            <div className="p-presReport__card">
                <SkeletonLoader isLoading={isLoading}>
                    <ReportProgressBar
                        label="Average points scored"
                        value={analytics?.averageScore || 0}
                        maxValue={analytics?.maxPossibleScore || 0}
                    />
                </SkeletonLoader>
            </div>
        </div>
    );
}

export default AveragePointsReport;
